module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"interviewAborted":"К сожалению интервью было прервано, т.к. вы отвечали на вопрос слишком долго. Обновите страницу и интервью будет продолжено с последнего вопроса.","continue":"Продолжить интервью"}}')
  delete Component.options._Ctor
}
